import { render, staticRenderFns } from "./tab-guess.vue?vue&type=template&id=00fc46f7&scoped=true&"
import script from "./tab-guess.vue?vue&type=script&lang=js&"
export * from "./tab-guess.vue?vue&type=script&lang=js&"
import style0 from "./tab-guess.vue?vue&type=style&index=0&id=00fc46f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc46f7",
  null
  
)

export default component.exports